import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import { IPrescription, Statuses } from 'API';
import { AccordionExpandIconBlue } from 'Components/AccordionExpandIconBlue';
import { CustomStepper } from 'Components/CustomStepper';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useState } from 'react';
import { ContactUs } from './ContactUs';
import { shorterDateFormat } from 'Config';
import { format } from 'date-fns';
import { PurpleCheckedBullet } from 'Images';
import { MedicineOrderStepper } from './MedicineOrderStepper';
import { MedicineStatusExtraInfo } from './MedicineStatusExtraInfo';
import { Status } from '../Status';

interface OrderStatusProps {
  order: IPrescription;
}
interface IStatusDate {
  statusDate: Date | undefined;
}
export const MedicineOrderStatus = ({ order }: OrderStatusProps) => {
  const isDesktop = useIsDesktop();
  const [isExpanded, setIsExpanded] = useState<boolean>(true);
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);

  const currentStatus = order.statuses.find(
    (s) => s.calcStatus === order.currentStatus
  );

  const getStatusLabel = () => currentStatus?.label || '';

  const getStatusDate = (currentStatus: IStatusDate | undefined) => {
    if (currentStatus && currentStatus.statusDate instanceof Date) {
      return format(currentStatus.statusDate, shorterDateFormat);
    }
    return '';
  };

  return isDesktop ? (
    <>
      <Typography mb={2} component={'h3'}>
        {dictionary.orderDialog.statusTitle}
      </Typography>

      <Stack
        sx={{
          background: '#fff',
          border: '1px solid',
          borderColor: 'primary.shade_200',
          borderRadius: '16px',
          mb: 7,
        }}
      >
        {/* {order.currentStatus !== Equipment_Order_STATUSES.finished ? ( */}
        <Stack flexDirection={'row'}>
          <MedicineOrderStepper
            steps={order.statuses}
            currentStep={order.currentStatus}
          />
          <Stack
            flexDirection={'column'}
            justifyContent={'start'}
            alignItems={'end'}
            p={3}
          >
            <MedicineStatusExtraInfo
              stepStatus={currentStatus || ({} as Statuses)}
            />
            <ContactUs order={order} />
          </Stack>
        </Stack>
        {/* ) : (
           <Typography sx={{ textAlign: 'center' }}>
             {getStatusLabel || ''}
           </Typography>
         )} */}
      </Stack>
    </>
  ) : (
    <>
      <Typography mb={2}>{dictionary.orderDialog.status}</Typography>
      <Accordion
        defaultExpanded
        sx={{
          width: '100%',
          boxShadow: 'none',
          border: '1px solid',
          borderColor: 'primary.shade_200',
          borderRadius: '16px !important',
          '&:before': {
            display: 'none',
          },
          mb: '24px !important',
        }}
      >
        <AccordionSummary
          onClick={() => {
            setIsExpanded(!isExpanded);
          }}
          expandIcon={<AccordionExpandIconBlue />}
          sx={{ p: '10px 16px ' }}
        >
          <Stack>
            <Stack flexDirection={'row'}>
              <Avatar
                src={PurpleCheckedBullet}
                sx={{ width: '24px', height: '24px', mr: '12px' }}
                alt=''
              />
              <Status
                status={order.currentStatus}
                statusLabel={getStatusLabel() || ''}
              />
            </Stack>

            <Typography variant={'body5'} sx={{ ml: '36px', mt: '4px' }}>
              {getStatusDate}
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 2 }}>
          <Grid
            sx={{
              '.MuiStepper-root > .MuiStepConnector-vertical:first-of-type': {
                display: 'none',
              },
              '.MuiStepper-root > .MuiStep-root:nth-of-type(2)': {
                visibility: 'hidden',
              },
            }}
          >
            <CustomStepper
              steps={order.statuses.map((s) => ({
                key: s.calcStatus,
                name: s.label || '',
              }))}
              activeStepIndex={
                order.currentStatus === 1
                  ? order.currentStatus - 1
                  : order.currentStatus - 2
              }
              slideContent={
                <MedicineStatusExtraInfo
                  stepStatus={currentStatus || ({} as Statuses)}
                />
              }
            />
          </Grid>
        </AccordionDetails>
      </Accordion>
    </>
  );
};
